import React from "react";
import "./SimilarProducts.css"; // Import external CSS
import S1 from '../../assets/S1.png'
import S2 from '../../assets/S2.png'
import S3 from '../../assets/S3.png'
import S4 from '../../assets/S4.png'
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import logger from "../../Utils/logger";


const SimilarProducts = ({similarProduct,AddIntoCart,RemovefromCart}) => {
 const {machine_id} =useParams()
const handleAddToCart=(e,index,slotid,count,machineId)=>{
  //logger.log("khan slotid----",index,slotid,count,machine_id)

AddIntoCart({e, i:index, sId:slotid, myCartcount:count, machine_id:machine_id,replace:false})

}
const handleRemoveToCart=(e,index,slotid,count,machineId)=>{
  RemovefromCart(e,index,slotid,count,machineId)
 }

     const GotoDetails=(e,data)=>{
        //logger.log("GotoDetails",data)
        const machineId=localStorage.getItem("machineId")
      //window.location.href = `/productdetails/${machineId}/${data.mv_id}/${data.slot_id}`;

      }
 

  return (
    <div className="container-similar">
      {similarProduct&&similarProduct[0]&&<h2 className="title" style={{textAlign:"start",color: "#384F6F",fontSize:"12px"}}>Similar Product</h2>}
      <div className="product-list">
        {similarProduct.map((product,index) => (
         
          <div key={product.id} className="product-card" onClick={(e)=>{GotoDetails(e,product)}}>
             {//logger.log("tahzeeb product--------map----->",product)
             
             }
            <img src={	`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${product.image_path}`} alt={product.mv_name} className="product-image"  style={{opacity:product.active_count?"":.5}} />
            <div style={{    display: "flex",
    justifyContent:"flex-end",    marginRight: "5px",position: "relative",top: "-9vw"}}>
            {product.mycount==0?
            <>{product.active_count>0&&

            <button className="add-button" onClick={(e) => handleAddToCart(e,index,product.slot_id,0,machine_id)}>Add</button>}</>
            :
           
            <div style={{border:"",background:" #00B177", borderRadius:"5px",width:"50%",color:"white",    display: "flex",justifyContent:"space-around",position:"absolute",padding: "1vw"}}>
              <span onClick={(e)=>handleRemoveToCart(e,product.slot_id,product.mycount,machine_id)}>-</span>{product.mycount}<span onClick={(e)=>handleAddToCart(e,index,product.slot_id,product.mycount,machine_id)}>+</span></div>
              
            
              }

          
            </div>
            <p className="product-weight"  style={{opacity:product.active_count?"":.5,padding: "2px",textAlign:"center",marginTop: "4vw",background: "#F5FCFA",color:"#384F6F",fontSize:"8px"}}>Item Left . {product.active_count}</p>
            
            <p className="product-name" style={{textAlign: "start",opacity:product.active_count?"":.5,textAlign: "start",fontSize: "10px",padding:"10px",    paddingBottom:"0",color: "#384F6F"}} >{product.mv_name}</p>
            <p className="product-tray" style={{ textAlign: "start", opacity: product.active_count ? "" : 0.5 ,paddingLeft:"10px"}}>Tray: {String(product.slot_id).substring(0, 1)}
</p>            <p className="product-price" style={{textAlign: "start",opacity:product.active_count?"":.5,fontSize: "10px",textAlign:"start",fontSize: "10px",
    paddingLeft: "10px",
    paddingBottom: "12px",color:"#718198"  }}>₹{" "}{product.offer_price.toFixed(2)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimilarProducts;
